import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { reverseUrl } from '../../navigation/reverseUrl'
import { SocietyErrorViewWrapper } from '../error/SocietyErrorViewWrapper'
import { useSocietyLoader } from '../../navigation/society/hooks/useSocietyLoader'
import { useCurrentSociety } from '../../hooks/useCurrentSociety'

const SocietyView = (): React.ReactNode => {
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const { society, isLoading } = useCurrentSociety()
  useSocietyLoader(id)

  useEffect(() => {
    !id &&
      society?._id &&
      !isLoading &&
      location.pathname === `/society` &&
      navigate(reverseUrl('society:detail', { id: society._id }), {
        replace: true,
      })
  }, [id, isLoading, location.pathname, navigate, society?._id])

  return (
    <SocietyErrorViewWrapper>
      <Outlet />
    </SocietyErrorViewWrapper>
  )
}

SocietyView.displayName = 'SocietyView'
export { SocietyView }
